var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"id":"themed-card","height":_vm.height,"width":_vm.width,"flat":_vm.flat,"outlined":_vm.outlined,"hover":_vm.hover,"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }